import { useRef } from 'react';
import HeroSection from './components/HeroSection';
import VantaggiSection from './components/VantaggiSection';
import DettagliEventoSection from './components/DettagliEventoSection';
import ModuloContattiSection from './components/ModuloContattiSection';
import ChiSiamoSection from './components/ChiSiamoSection';
import CorsiSection from './components/CorsiSection';

export default function HomePage() {
  const moduloRef = useRef<HTMLElement | null>(null);

  const scrollToForm = () => {
    if (moduloRef.current) {
      moduloRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <main className="bg-black min-h-screen overflow-x-hidden">
      <HeroSection onCtaClick={scrollToForm} />
      <VantaggiSection />
      <DettagliEventoSection onCtaClick={scrollToForm} />
      <ModuloContattiSection sectionRef={moduloRef} />
      <ChiSiamoSection />
      <CorsiSection onCtaClick={scrollToForm} />
    </main>
  );
}
